(function ($) {
  $(document).ready(function () {

    const $section = $('#BlogFilterSection');
    if (!$section.length) return;

    const blogHandle = $section.data('blog-handle');
    const $grid = $('#BlogGrid');
    const $loadMore = $('#LoadMoreBtn');
    const $loading = $('#BlogLoading');

    const PER_PAGE = 6;

    let page = 1;
    let activeTag = '';
    let activeLevels = [];

    function buildUrl(p) {
      let url = `/blogs/${blogHandle}`;
      if (activeTag) url += `/tagged/${activeTag}`;
      url += `?view=ajax&page=${p}`;
      return url;
    }

    function fetchArticles(p, append = false) {
      $('.no-result').remove();

      // 👉 SHOW LOADING GIF
      $loading.fadeIn(150);

      if (!append) {
        $grid.css('opacity', 0.4);
      }

      $.ajax({
        url: buildUrl(p),
        method: 'GET',
        dataType: 'html',

        success: function (html) {
          const $temp = $('<div>').html(html);
          const $items = $temp.find('.blog-card');

          if (!append) {
            $grid.empty();
            page = 1;
          }

          let addedCount = 0;

          $items.each(function () {
            const level = $(this).data('kuchenlevel');
            if (activeLevels.length && !activeLevels.includes(level)) return;

            $grid.append(this);
            addedCount++;
          });

          // 👉 HIDE LOADING
          $loading.fadeOut(150);
          $grid.css('opacity', 1);

          if (addedCount < PER_PAGE) {
            $loadMore.hide();
          } else {
            $loadMore.show();
          }
        },

        error: function () {
          $loading.fadeOut(150);
          $grid.css('opacity', 1);

          if (!append) {
            $grid.html('<p class="no-result">Keine Rezepte gefunden.</p>');
          }

          $loadMore.hide();
        }
      });
    }

    /* TAG FILTER */
    $section.on('click', '.filter-tag', function (e) {
      e.preventDefault();

      $('.filter-tag').removeClass('active');
      $(this).addClass('active');

      activeTag = $(this).data('tag') || '';
      page = 1;

      fetchArticles(1, false);
    });

    /* LEVEL FILTER */
    $section.on('change', '.filter-level', function () {
      activeLevels = $('.filter-level:checked')
        .map(function () {
          return $(this).val();
        }).get();

      page = 1;
      fetchArticles(1, false);
    });

    /* LOAD MORE */
    $loadMore.on('click', function () {
      if ($loadMore.hasClass('loading')) return;

      $loadMore.addClass('loading').prop('disabled', true);
      page++;

      fetchArticles(page, true);

      setTimeout(() => {
        $loadMore.removeClass('loading').prop('disabled', false);
      }, 600);
    });

  });
})(jQuery);
